import React, { useEffect, useContext, useState } from "react";
import apiClient from "../../../../api/Api.js";
import { DataContext } from "../../../../context/dataprovider.js";
import Loader from "../../../../loader/loader.js";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  TextField,
} from "@mui/material";
import styles from "./Employers.module.css";

const Employers = () => {
  const Analysis_api = process.env.REACT_APP_ANALYTICS;
  const { userData = {}, loading } = useContext(DataContext);
  const { projectId } = userData;

  const [employeeData, setEmployeeData] = useState([]);
  const [projectSearch, setProjectSearch] = useState("");
  const [emailSearch, setEmailSearch] = useState("");

  const getEmployeesData = async () => {
    try {
      const response = await apiClient.post(
        `${Analysis_api}/get_employees_data`,
        { projectId }
      );
      setEmployeeData(response.data);
    } catch (error) {
      console.error("Error in Transaction Analysis:", error);
    }
  };

  useEffect(() => {
    if (projectId) {
      getEmployeesData();
    }
  }, [loading, projectId]);

  if (loading) {
    return <Loader />;
  }

  // Filter employee data
  const filteredEmployeeData = employeeData
    .filter((project) =>
      project.project_name.toLowerCase().includes(projectSearch.toLowerCase())
    )
    .map((project) => ({
      ...project,
      users_by_role: project.users_by_role.map((role) => ({
        ...role,
        users: role.users.filter((user) =>
          user.email.toLowerCase().includes(emailSearch.toLowerCase())
        ),
      })),
    }))
    .filter((project) =>
      project.users_by_role.some((role) => role.users.length > 0)
    );

  return (
    <div className={styles.container}>
      <Typography variant="h5" className={styles.title}>
        Project Employees
      </Typography>
      <br />
      <div className={styles.filters}>
        <Typography style={{ marginTop: "4px" }}>Search By :</Typography>
        <TextField
          label="Search by Project Name"
          variant="outlined"
          size="small"
          value={projectSearch}
          onChange={(e) => setProjectSearch(e.target.value)}
          className={styles.searchInput}
        />
        <TextField
          label="Search by User Email"
          variant="outlined"
          size="small"
          value={emailSearch}
          onChange={(e) => setEmailSearch(e.target.value)}
          className={styles.searchInput}
        />
      </div>

      {filteredEmployeeData.length > 0 ? (
        <TableContainer component={Paper} className={styles.tableContainer}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Project Name</TableCell>
                <TableCell>Role</TableCell>
                <TableCell>User Name</TableCell>
                <TableCell>User Email</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredEmployeeData.map((project) => (
                <React.Fragment key={project.project_name}>
                  {project.users_by_role
                    .filter((role) => role.users.length > 0)
                    .sort((a, b) => a.role.localeCompare(b.role))
                    .map((roleData, index) => (
                      <React.Fragment key={index}>
                        {roleData.users.map((user, userIndex) => (
                          <TableRow key={userIndex} className={styles.dataRow}>
                            {userIndex === 0 && (
                              <TableCell
                                rowSpan={roleData.users.length}
                                className={styles.projectCell}
                              >
                                {project.project_name}
                              </TableCell>
                            )}
                            {userIndex === 0 && (
                              <TableCell
                                rowSpan={roleData.users.length}
                                className={styles.roleCell}
                              >
                                {roleData.role}
                              </TableCell>
                            )}
                            <TableCell>{user.name}</TableCell>
                            <TableCell>{user.email}</TableCell>
                          </TableRow>
                        ))}
                      </React.Fragment>
                    ))}
                </React.Fragment>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <p className={styles.noData}>
          No employee data available for this project.
        </p>
      )}
    </div>
  );
};

export default Employers;
